export default {
  auth: {
    manageUsers: 'Manage Users',
    manageRoles: 'Manage Roles',
    manageScopes: 'Manage Scope',
  }
}
